<template>
  <cart-component v-if="is_cart_with_estimate" :edit-order="editOrder" :nav-icon="navIcon"></cart-component>
  <estimate-fixed v-else :edit-order="editOrder" :nav-icon="navIcon"></estimate-fixed>
</template>
<script type="text/javascript">
import {mapGetters} from "vuex"
import CartItemsComponent from "@/components/modules/hosted-pages/CartItemsComponent"
import EstimateFixed from "@/components/modules/hosted-pages/EstimateFixed"
export default {
  props: ['editOrder', 'navIcon'],
  computed: {
    ...mapGetters([
      'is_cart_with_estimate'
    ])
  },
  components: {
    'cart-component': CartItemsComponent,
    'estimate-fixed': EstimateFixed
  }
}
</script>
